import React, { memo } from "react";
import { Box, Center, Heading, Text } from "@chakra-ui/react";

const ErrorScreen = () => {
  return (
    <Center my={20}>
      <Box
        textAlign="center"
        p={10}
        bg="white"
        borderRadius="md"
        boxShadow="md"
      >
        <Heading mb={4} size="lg">
          Oops! Something Went Wrong.
        </Heading>
        <Text mb={4}>
          We're sorry, but we can't process your request at the moment.
        </Text>
        <Text mb={4}>
          Please try again later or contact our support team for help.
        </Text>
      </Box>
    </Center>
  );
};

export default memo(ErrorScreen);
